// extracted by mini-css-extract-plugin
export var addToCartButton = "_qa-b";
export var arrowButtonContainer = "_qa-9";
export var arrowButtonIcon = "_qa-a";
export var carouselArrowButton = "_qa-6";
export var carouselElementContainer = "_qa-1";
export var left = "_qa-7";
export var productDisplayCarouselContainer = "_qa-0";
export var productTileContainer = "_qa-2";
export var productTileImage = "_qa-4";
export var productTileImageContainer = "_qa-3";
export var productTileTitle = "_qa-5";
export var right = "_qa-8";
export var sliderOverflow = "_qa-c";